module.exports = __webpack_public_path__ + "img/equipo_16-9.3d7bfb49.jpg";